<template>
  <Modal
    class="cc-modal"
    width="600"
    footer-hide
    v-model="visibility"
    title="设置邮箱"
  >
    <div class="content" style="position: relative">
      <loading :loading="loading" style="z-index: 11"></loading>
      <div class="section">
        <div class="col">
          <div class="name">邮箱：</div>
          <Input
            class="height45"
            v-model="form.yx"
            placeholder="请输入邮箱"
            style="width: 200px"
            clearable
          />
        </div>
      </div>
    </div>
    <div class="foot">
      <Button
        :loading="loading"
        @click="onConfirm"
        type="primary"
        style="margin-right: 20px"
        >确定</Button
      >
      <Button @click="onCancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
import { userEmailAdd } from "api/customer.js";
import { mapMutations } from "vuex";
import loading from "components/loading.vue";
export default {
  name: "addEmailModal",
  components: {
    loading,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        yx: "",
      },
      loading: false,
    };
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    ...mapMutations(["MUT_TOKEN_INFO"]),
    // 取消
    onCancel() {
      this.form = this.$options.data().form;
      this.visibility = false;
    },
    // 确认
    async onConfirm() {
      if (!this.form.yx) {
        this.$Message.warning("请输入邮箱！");
        return;
      }
      this.loading = true;
      try {
        const res = await userEmailAdd(this.form);
        this.loading = false;
        if (res.code === 200 && res.result) {
          this.$emit("submit-success", (res) => {
            if (res) {
              this.onCancel();
              this.$Message.success("设置成功！");
            }
          });
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.col {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
  .name {
    color: #333333;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .label {
    color: #999999;
  }
}
.upload-section {
  width: 200px;
  height: 122px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 45px;
    height: 35px;
  }
}
.icon2 {
  border: 1px dashed #dcdee2;
  position: relative;
  width: 200px;
  height: 122px;
  background-size: cover;
  background-position: center;
  .close {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
}
</style>
<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
</style>
